import { keysToCamelCase } from '@hotjar/webapp/lib/convert-string';
import { mapOwnedAccountDtoToModel } from '@hotjar/account';
import type {
  User as UserDto,
  CurrentUser as CurrentUserDto,
  PartialCurrentUser as PartialCurrentUserDto,
} from './dto';
import type {
  User as UserModel,
  CurrentUser as CurrentUserModel,
  PartialCurrentUser,
} from './model';

export function dtoToModel(user: UserDto): UserModel {
  return {
    id: user.id,
    name: user.name,
    email: user.email,
    avatar: user.picture_url,
  };
}

export function modelToDto(user: UserModel): UserDto {
  return {
    id: user.id,
    name: user.name,
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    email: user.email || '',
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    picture_url: user.avatar || '',
  };
}

export function currentUserDtoToModel(user: CurrentUserDto): CurrentUserModel {
  return {
    success: user.success,
    accessKey: user.access_key,
    accountBillingCycle: user.account_billing_cycle,
    accountType: user.account_type,
    accounts: user.accounts?.map((account) => mapOwnedAccountDtoToModel(account)),
    becameACustomer: user.became_a_customer,
    btCustomerId: user.bt_customer_id,
    country: user.country,
    currency: user.currency,
    currentIp: user.current_ip,
    hasPaymentDetails: user.has_payment_details,
    invitesRemaining: user.invites_remaining,
    isAccountAdmin: user.is_account_admin,
    isAdminOfOneOrganization: user.is_admin_of_one_organization,
    isFoundingMember: user.is_founding_member,
    locale: user.locale,
    utmParams: user.utm_params,
    receiveAnalysisEmails: user.receive_analysis_emails,
    receiveFeedbackEmails: user.receive_feedback_emails,
    recurringPaymentFailed: user.recurring_payment_failed,
    referralCode: user.referral_code,
    showIncompleteHeatmapModal: user.show_incomplete_heatmap_modal,
    subscribeToEmails: user.subscribe_to_emails,
    created: user.user_created,
    email: user.user_email,
    emailBlocked: user.user_email_blocked,
    id: user.user_id,
    name: user.user_name,
    avatar: user.user_picture_url,
    role: user.user_role,
    isSSOOnly: user.user_is_sso_only,
    isEnterpriseSSO: user.user_is_enterprise_sso,
    isEmailVerified: user.is_email_verified,
    isSuperuser: user.is_superuser,
    isDemoUser: user.is_demo_user,
  };
}

export const mapPartialCurrentUserDtoToModel = (user: PartialCurrentUserDto): PartialCurrentUser =>
  keysToCamelCase(user);
